import {
  Col,
  Input,
  InputNumber,
  Layout,
  Row,
  Select,
  Space,
  Table,
} from 'antd';
import { Content } from 'antd/es/layout/layout';
import React, { memo, useState } from 'react';
import formatCurrencyVND from 'utils/formatCurrencyVND';
import CheckableTag from 'antd/es/tag/CheckableTag';
import { useHistory } from 'react-router-dom';
import { HocChangePagination } from 'utils/HocChangePagination';
import { EyeIcon } from 'assets/svg';
import { ColumnsType } from 'antd/es/table';
import { useQuery } from 'react-query';
import ProductApi from 'apis/ProductApi';

export interface IProps {
  data?: any;
  isLoading?: any;
  id: any;
  cartOrderBranchId: any;
  isViewDetailAllBranch: any;
}

const sortData = [
  'Mới nhất',
  'Bán chạy',
  'Đăng ký kỳ trước',
  'Sức bán trung bình',
];

const TableDetailApproveOrder = ({
  data,
  isLoading,
  id,
  cartOrderBranchId,
  isViewDetailAllBranch,
}: IProps) => {
  const history = useHistory();
  const { Option } = Select;

  const [selectedTags, setSelectedTags] = useState<string>();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [bstSelected, setBstSelected] = useState<any[]>();
  const [products, setProducts] = useState<any>({ order_max: 0, order_min: 0 });
  console.log('products: ', products);

  const { data: lstProductOption } = useQuery(
    ['getProductOption'],
    () => ProductApi.getProductOption() // lấy ds option
  );

  function ChangeValueMin(value: any) {
    const newProduct = {
      ...products,
      order_min: !value ? undefined : Number(value),
    };
    // handleMinMaxProduct(index, newProduct);
    setProducts({
      ...products,
      order_min: !value ? undefined : Number(value),
    });
  }

  function ChangeValueMax(value: any) {
    const newProduct = {
      ...products,
      order_max: !value ? undefined : Number(value),
    };
    // handleMinMaxProduct(index, newProduct);
    setProducts({
      ...products,
      order_max: !value ? undefined : Number(value),
    });
  }

  const bst = lstProductOption?.data?.filter(
    (option: any) => option.type === 'bst'
  )[0]['list'];

  const handleChange = (tag: string, checked: boolean) => {
    if (tag == selectedTags) {
      setSelectedTags(undefined);
    } else {
      setSelectedTags(tag);
    }
    // history.push('/order-product-list/create', {
    //   cart: cart,
    //   lstSelected: productListSelected,
    //   page: 1,
    //   page_size: page_size,
    // });
  };

  const columns: ColumnsType<any> = [
    // {
    //   title: 'STT',
    //   dataIndex: 'cart_register_detail_id',
    //   width: 80,
    //   //   render: (text, record, index) => index + 1 + page_size * (page - 1),
    // },
    {
      title: 'Hình ảnh',
      dataIndex: 'image_default',
      render: (image_default: any) => (
        <img style={{ height: 50 }} src={image_default} />
      ),
      width: 50,
    },
    // {
    //   title: 'Mã basic (new)',
    //   dataIndex: 'basic_product',
    //   width: 100,
    // },
    {
      title: 'Mã mẫu',
      dataIndex: 'ma_mau',
      sorter: (a, b) => a.ma_mau - b.ma_mau,
      width: 75,
    },
    // {
    //   title: 'Mã sản phẩm',
    //   dataIndex: 'product_code',
    //   width: 100,
    // },
    {
      title: 'Tên sản phẩm',
      dataIndex: 'ten_mau',
      width: 100,
    },
    // {
    //   title: 'Ngành hàng',
    //   width: 115,
    //   dataIndex: 'prod_grp2_name',
    // },
    // {
    //   title: 'Dòng hàng SAP',
    //   dataIndex: 'line_sap',
    //   width: 148,
    // },
    // {
    //   title: 'Dòng hàng Xman',
    //   dataIndex: 'line_xman_text',
    //   width: 148,
    // },
    // {
    //   title: 'Xman',
    //   dataIndex: 'xman',
    //   width: 200,
    // },
    // {
    //   title: 'Chủng loại',
    //   dataIndex: 'chungloai_text',
    //   width: 112,
    // },
    // {
    //   title: 'Giá vốn tồn tham khảo',
    //   dataIndex: 'cost_price',
    //   width: 185,
    //   align: 'end',
    //   render: (value: number) => {
    //     return <>{formatCurrencyVND(value)}</>;
    //   },
    // },
    // {
    //   title: 'Giá bán',
    //   dataIndex: 'price',
    //   width: 135,
    //   align: 'end',
    //   render: (value: number) => {
    //     return <>{formatCurrencyVND(value)}</>;
    //   },
    // },
    // {
    //   title: 'Giá vốn bình quân',
    //   dataIndex: 'cost_price',
    //   width: 157,
    //   align: 'end',
    //   render: (value: number) => {
    //     return <>{formatCurrencyVND(value)}</>;
    //   },
    // },
    // {
    //   title: 'Phân khúc giá',
    //   dataIndex: 'phankhuc_gia',
    //   width: 157,
    // },
    // {
    //   title: 'Loại đá',
    //   dataIndex: 'loai_da',
    //   width: 124,
    // },
    // {
    //   title: 'Nhóm đá',
    //   dataIndex: 'nhom_da',
    //   width: 124,
    // },
    // {
    //   title: 'Aging',
    //   dataIndex: 'aging',
    //   width: 157,
    // },
    // {
    //   title: 'BST',
    //   dataIndex: 'bst_text',
    //   width: 60,
    // },
    // {
    //   title: 'Mã bộ',
    //   dataIndex: 'zma_bo',
    //   width: 250,
    // },
    // {
    //   title: 'Mã cặp',
    //   dataIndex: 'zma_ts_cap',
    //   width: 250,
    // },
    // {
    //   title: 'Giới tính',
    //   dataIndex: 'gioitinh_text',
    //   width: 90,
    // },
    // {
    //   title: 'Material Type',
    //   dataIndex: 'product_type_code',
    //   width: 126,
    // },
    // {
    //   title: 'Tuổi vàng',
    //   dataIndex: 'purity_of_gold',
    //   width: 99,
    // },
    // {
    //   title: 'Màu sắc',
    //   dataIndex: 'mausac_text',
    //   width: 120,
    // },
    // {
    //   title: 'Size ổ hột',
    //   dataIndex: 'ohot_kc',
    //   width: 99,
    // },
    // {
    //   title: 'Xplant Status',
    //   dataIndex: 'xplant_status',
    //   width: 125,
    // },
    // {
    //   title: 'Phân nhóm',
    //   dataIndex: '',
    //   width: 204,
    // },
    // {
    //   title: 'Trạng thái mẫu',
    //   dataIndex: '',
    //   width: 135,
    // },
    // {
    //   title: 'Is_DMHHKN',
    //   dataIndex: 'is_dmhhkn',
    //   width: 115,
    // },
    // {
    //   title: 'PLHH',
    //   dataIndex: 'plhh',
    //   width: 114,
    // },
    // {
    //   title: 'Material (Mẫu đại diện)',
    //   dataIndex: 'mau_dai_dien',
    //   width: 190,
    //   render: (value: any) => {
    //     return <>{value.toString()}</>;
    //   },
    // },
    // {
    //   title: 'Material Group',
    //   dataIndex: 'material_group',
    //   width: 134,
    // },
    // {
    //   title: 'PL ni => Khung ni chuẩn (hàng mới)',
    //   dataIndex: 'item_size',
    //   width: 270,
    // },
    // {
    //   title: 'DGTQ',
    //   dataIndex: 'kldg_3tc',
    //   width: 73,
    // },
    // {
    //   title: 'PL tình trạng theo dõi NLSX',
    //   dataIndex: '',
    //   width: 219,
    // },
    // // {
    // //   title: 'Danh mục cũ',
    // //   dataIndex: '',
    // //   width: 121,
    // // },
    // // {
    // //   title: 'Danh mục',
    // //   dataIndex: '',
    // //   width: 114,
    // // },
    // {
    //   title: 'Basic status',
    //   dataIndex: 'basic_status',
    //   width: 177,
    // },
    // {
    //   title: 'Trạng thái sản phẩm',
    //   width: 171,
    //   dataIndex: 'status',
    // },
    // {
    //   title: 'Vòng đời giỏ hàng hiện tại',
    //   width: '200px',
    //   dataIndex: '',
    // },
    // {
    //   title: 'Doanh thu 6 tháng gần nhất',
    //   align: 'right',
    //   dataIndex: 'doanhthu_6th',
    //   width: 100,
    // },
    // {
    //   title: 'Doanh thu TB 1 tháng (VND)',
    //   align: 'right',
    //   dataIndex: 'doanhthu_tb_1th',
    //   width: 200,
    // },
    // {
    //   title: 'Trạng thái bán hàng',
    //   width: 168,
    //   //   render: (product: IProduct) => (
    //   //     <span>
    //   //       {/* {PRODUCT_STATUS.find((item) => item.value === product.status)?.label} */}
    //   //     </span>
    //   //   ),
    // },
    // {
    //   title: 'Tổng SL tồn hiện tại',
    //   align: 'right',
    //   dataIndex: 'tongsl_ton',
    //   width: 100,
    // },
    // {
    //   title: 'Tổng SL Tổng giá trị',
    //   align: 'right',
    //   dataIndex: 'tong_giatri',
    //   width: 100,
    // },
    // {
    //   title: 'Product Family',
    //   dataIndex: '',
    //   width: 150,
    // },
    // {
    //   fixed: 'right',
    //   width: 100,
    //   align: 'center',
    //   //   render: (product: IProduct) => (
    //   //     <div className="flex justify-around">
    //   //       <button
    //   //         onClick={() => {
    //   //             goToDetail(product.product_code);
    //   //         }}
    //   //       >
    //   //         <EyeIcon />
    //   //       </button>
    //   //       {/* <button>
    //   //         <EditIcon />
    //   //       </button> */}
    //   //     </div>
    //   //   ),
    // },
    {
      title: 'Đăng ký',
      dataIndex: '',
      width: 170,
      fixed: 'right',
      render: () => {
        return (
          <Row>
            <Col>
              <Row align="bottom" gutter={10}>
                <Col span={5} style={{ flex: 1 }}>
                  <Row align={'middle'} justify="center">
                    <div style={{ fontSize: '8px', fontWeight: 'bold' }}>
                      {'Min: '}{' '}
                      <strong style={{ fontSize: '10px' }}>
                        {/* {product.old_order_min} */}0
                      </strong>
                    </div>
                  </Row>

                  <InputNumber
                    // controls={false}
                    min={0}
                    style={{
                      height: '28px',
                      width: '100%',
                      borderRadius: '5px',
                    }}
                    onChange={ChangeValueMin}
                    // // onBlur={(event) => handleValidateMin(event)}
                    defaultValue={products.order_min}
                    // value={products?.order_min}
                  />
                </Col>
                <Space></Space>

                <Col span={5} style={{ flex: 1 }}>
                  <Row align={'middle'} justify="center">
                    <div style={{ fontSize: '8px', fontWeight: 'bold' }}>
                      {'Max: '}
                      <strong style={{ fontSize: '10px' }}>
                        {/* {product.old_order_max} */}0
                      </strong>
                    </div>
                  </Row>
                  <InputNumber
                    min={0}
                    style={{
                      height: '28px',
                      width: '100%',
                      borderRadius: '5px',
                      textAlign: 'center',
                    }}
                    onChange={ChangeValueMax}
                    // // onBlur={(event) => handleValidateMax(event)}
                    defaultValue={products.order_max}
                    // value={products?.order_max}
                  />
                </Col>
                <Col className=" flex flex-col" style={{ fontSize: '10px' }}>
                  <strong
                    className="text-secondary cursor-pointer"
                    // onClick={() =>
                    //   showModal({ product, ChangeValueMin, ChangeValueMax })
                    // }
                  >
                    {/* {product.order_min
                      ? formatCurrencyVND(item.cost_price * product.order_min)
                      : '0đ'} */}
                    1 000 000 000{' - '}2 000 000 000
                    {/* {product.order_max
                      ? formatCurrencyVND(item.cost_price * product.order_max)
                      : '0đ'} */}
                  </strong>
                  <strong>Đề xuất</strong>
                </Col>
              </Row>
            </Col>

            <Col style={{ marginTop: '5px' }}>
              <Row>
                <p style={{ fontSize: '10px', color: '#DC362E' }}>
                  {/* {product.order_min <= 0
                  ? 'Số lượng min không được nhỏ hơn hoặc bằng 0'
                  : ''} */}
                </p>
              </Row>
              <Row>
                <p style={{ fontSize: '10px', color: '#DC362E' }}>
                  {/* {product.order_min > product.order_max
                  ? 'Số lượng min không được lớn hơn số lượng max'
                  : ''} */}
                </p>
              </Row>
              <Row>
                <p style={{ fontSize: '10px', color: '#DC362E' }}>
                  {/* {product.order_min >= 5
                  ? 'Số lượng đăng kí MIN quá lớn (trên 4 món)'
                  : ''} */}
                </p>
              </Row>
              <Row>
                <p style={{ fontSize: '10px', color: '#DC362E' }}>
                  {/* {product.order_max >= 5
                  ? 'Số lượng đăng kí MAX quá lớn (trên 4 món)'
                  : ''} */}
                </p>
              </Row>
              <Row>
                <p style={{ fontSize: '10px', color: '#DC362E' }}>
                  {/* {product.order_max - product.order_min >= 4
                  ? 'Số lượng chênh lệch giữa MIN-MAX quá lớn (trên 3 món)'
                  : ''} */}
                </p>
              </Row>
              <Row>
                <p style={{ fontSize: '10px', color: '#DC362E' }}>
                  {/* {renderPairValidate()} */}
                </p>
              </Row>
            </Col>
          </Row>
        );
      },
    },
  ];

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <Layout style={{ backgroundColor: '#F1F9FF' }}>
      <Col
        style={{
          backgroundColor: '#ffffff',
          // marginTop: '20px',
          paddingLeft: '20px',
          paddingRight: '20px',
          paddingTop: '10px',
          paddingBottom: '10px',
        }}
      >
        {/* <Row>
          <Col span={20}>
            <Row>
              <Col style={{ paddingRight: '4px' }}>
                Tổng mẫu: <strong>{data?.total}</strong>
              </Col>

              <Col style={{ paddingLeft: '4px' }}>
                - Đã chọn: <strong>{selectedRowKeys.length}</strong>
              </Col>
              <Col style={{ paddingLeft: '4px' }}>
                - Chưa chọn:{' '}
                <strong>{data?.total - selectedRowKeys.length}</strong>
              </Col>
            </Row>
          </Col>
          <Col span={4} className="flex justify-end">
            Kết quả lọc:&nbsp;<strong>0</strong>&nbsp;mẫu
          </Col>
        </Row> */}
        <Row justify={'space-between'} className="py-[8px] border-b-2">
          <Row>
            <Col style={{ paddingRight: '4px' }}>Đăng ký MIN:</Col>
            <Col style={{ fontWeight: 'bold' }}>
              {formatCurrencyVND(data?.order_shop?.shop_cap_order_min || 0)}
            </Col>
            <Col style={{ paddingRight: '4px', paddingLeft: '8px' }}>MAX:</Col>
            <Col style={{ fontWeight: 'bold' }}>
              {formatCurrencyVND(data?.order_shop?.shop_cap_order_max || 0)}
            </Col>
          </Row>
          <Row>
            <Col style={{ paddingRight: '4px' }}>Vốn ĐK tạm tính:</Col>
            <Col style={{ color: '#C9A46D', fontWeight: 'bold' }}>
              {formatCurrencyVND(data?.order_shop?.von_min || (0).toFixed(0))} -{' '}
              {formatCurrencyVND(data?.order_shop?.von_max || (0).toFixed(0))}
              {/* {formatCurrencyVND(
                productListSelected.reduce((acc: any, product: any) => {
                  return (
                    acc + (product.order_min ?? 0) * (product.cost_price ?? 0)
                  );
                }, 0)
              )}
              {' - '}
              {formatCurrencyVND(
                productListSelected.reduce((acc: any, product: any) => {
                  return (
                    acc + (product.order_max ?? 0) * (product.cost_price ?? 0)
                  );
                }, 0)
              )} */}
            </Col>
          </Row>
        </Row>
        <Row>
          <p
            onClick={() =>
              history.push(`/order/cht-view/${id}`, {
                cart: data,
                cartOrderBranchId,
                isViewDetailAllBranch,
                isExportAsTVV: false,
              })
            }
            className="text-primary-50 font-bold cursor-pointer"
          >
            Xem thêm
          </p>
        </Row>
      </Col>

      {/* <Content
        style={{
          backgroundColor: '#EFF3F8',
          marginTop: '20px',
          paddingTop: '20px',
          paddingLeft: '0px',
        }}
      >
        <Row
          justify={'space-between'}
          style={{
            paddingBottom: '10px',
            paddingLeft: '18px',
            paddingRight: '0px',
            alignItems: 'center',
          }}
        >
          <Row gutter={25} align={'middle'}>
            <Col className="font-bold">Sắp xếp theo</Col>
            <Space size={[0, 5]} wrap>
              {sortData.map((tag) => (
                <CheckableTag
                  key={tag}
                  checked={selectedTags?.includes(tag) ?? false}
                  onChange={(checked) => handleChange(tag, checked)}
                  style={{
                    borderRadius: '10px',
                    paddingLeft: '16px',
                    paddingRight: '16px',
                    backgroundColor: selectedTags?.includes(tag)
                      ? '#00538F'
                      : '#FFFFFF',
                    color: selectedTags?.includes(tag) ? '#FFFFFF' : '#757779',
                  }}
                >
                  {tag}
                </CheckableTag>
              ))}
            </Space>
          </Row>
          <Row>
            <Select
              size="small"
              placeholder="Sắp xếp nâng cao"
              allowClear
              value={bstSelected}
              onChange={(value) => {
                setBstSelected(value);
                // pushNewPage();
              }}
            >
              {bst &&
                bst.map((item: any) => (
                  <Option value={item.bst} key={item.bst}>
                    {item.bst_text}
                  </Option>
                ))}
            </Select>

            {/* <Form.Item
                    name="sort"
                    style={{
                      marginBottom: '0px',
                      marginLeft: '8px',
                    }}
                  >
                    <Select
                      defaultValue={'Sắp xếp'}
                      size="small"
                      suffixIcon={<SortAscendingOutlined />}
                      style={{ width: '120px' }}
                    />
                  </Form.Item> */}
      {/* </Row>
        </Row>
        <Content className="main-content mt-4">
          <Table
            rowKey={(record) => record.cart_register_detail_id}
            size="small"
            className="customTable"
            columns={columns}
            dataSource={data?.data}
            pagination={{
              hideOnSinglePage: true,
              className: 'flex items-center',
              //   current: page,
              //   pageSize: page_size,
              //   total: total,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '50'],
              onChange: HocChangePagination(history),
            }}
            scroll={{ x: 958 }}
            // loading={isLoading}
            rowSelection={rowSelection}
          />
        </Content> */}
      {/* </Content> */}
    </Layout>
  );
};

export default memo(TableDetailApproveOrder);
